// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { getStream } from "./getSSEs.js";
import { wrapError } from "./util.js";
import { createSseStream } from "@azure/core-sse";
import { polyfillStream } from "./readableStreamUtils.js";
export async function getOaiSSEs(response, toEvent) {
    const stringStream = await getStream(response);
    const eventStream = createSseStream(stringStream);
    const jsonParser = new TransformStream({
        transform: async (chunk, controller) => {
            if (chunk.data === "[DONE]") {
                return;
            }
            controller.enqueue(toEvent(wrapError(() => JSON.parse(chunk.data), "Error parsing an event. See 'cause' for more details")));
        },
    });
    /** TODO: remove these polyfills once all supported runtimes support them */
    return polyfillStream(eventStream.pipeThrough(jsonParser));
}
//# sourceMappingURL=oaiSse.js.map